import React from 'react';

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-[50vh] w-full">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-gold"></div>
  </div>
);

export default LoadingSpinner;
